"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PassengersConfig = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const ColumnsBlock_1 = require("../../../ColumnsBlock");
const Number_1 = require("../../../Form/Field/Number");
const Sub_1 = require("../../../Page/Title/Sub");
class PassengersConfig extends react_1.default.PureComponent {
    constructor() {
        super(...arguments);
        this.state = {
            ...this.props.passengersConfig,
        };
        this.handleAdultsChange = (adult) => {
            const updatedAdults = Math.max(0, adult);
            this.setState({
                adult: updatedAdults,
                infant: Math.min(updatedAdults, this.state.infant),
            }, () => this.props.onChange(this.state));
        };
        this.handleChildrenChange = (child) => {
            this.setState({ child: Math.max(0, child) }, () => this.props.onChange(this.state));
        };
        this.handleInfantsChange = (infant) => {
            this.setState({ infant: Math.max(0, Math.min(this.state.adult, infant)) }, () => this.props.onChange(this.state));
        };
    }
    render() {
        const { adult, child, infant, } = this.state;
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(Sub_1.PageSubTitle, { icon: 'customer', text: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Reservation/StepTravelDate/PassengersConfig:title', defaultMessage: 'Passengers' }), modificators: ['margin-bottom-sm'] }),
            react_1.default.createElement(ColumnsBlock_1.ColumnsBlock, { modificators: ['md'] },
                react_1.default.createElement("div", null,
                    react_1.default.createElement(Number_1.FormFieldNumber, { label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Reservation/StepTravelDate/PassengersConfig/Input/Adult:label', defaultMessage: 'Adults (12y+)' }), setValue: this.handleAdultsChange, value: adult })),
                react_1.default.createElement("div", null,
                    react_1.default.createElement(Number_1.FormFieldNumber, { label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Reservation/StepTravelDate/PassengersConfig/Input/Child:label', defaultMessage: 'Children (2-12y)' }), setValue: this.handleChildrenChange, value: child })),
                react_1.default.createElement("div", null,
                    react_1.default.createElement(Number_1.FormFieldNumber, { label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Reservation/StepTravelDate/PassengersConfig/Input/Infant:label', defaultMessage: 'Infants {lessThanTwo}', values: { lessThanTwo: '(<2y)' } }), info: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Reservation/StepTravelDate/PassengersConfig/Input/Infant:labelTooltip', defaultMessage: 'Every infant needs at least one accompanying adult', values: { lessThanTwo: '(<2y)' } }), setValue: this.handleInfantsChange, value: infant })))));
    }
}
exports.PassengersConfig = PassengersConfig;
PassengersConfig.defaultProps = {
    passengersConfig: {
        adult: 1,
        child: 0,
        infant: 0,
    },
    onChange: () => {
    },
};
//# sourceMappingURL=index.js.map